(function (Drupal, once) {
  'use strict';

  function loadIframe(facade) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('title', 'Video de YouTube');
    iframe.setAttribute('data-cookieconsent', 'marketing');
    iframe.setAttribute('data-cookieblock-src', facade.dataset.videoUrl);
    facade.replaceWith(iframe);
  }

  function hasVideoConsent() {
    return typeof Cookiebot !== 'undefined' &&
      (Cookiebot.consent.statistics || Cookiebot.consent.marketing);
  }

  Drupal.behaviors.youtubeFacade = {
    attach(context) {
      once('youtube-facade', '.youtube-facade', context).forEach(facade => {
        if (hasVideoConsent()) {
          loadIframe(facade);
        }
      });
    }
  };

  window.addEventListener('CookiebotOnAccept', function () {
    if (hasVideoConsent()) {
      document.querySelectorAll('.youtube-facade').forEach(loadIframe);
    }
  });

})(Drupal, once);
